





























































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import MapModule from '@/store/MapModule';
import SideBarLayout from '@/layouts/prescriber/components/SideBarLayout.vue';
import SideBarPrescriber from '@/components/prescriber/SideBarPrescriber.vue';
import MapPrescriber from '@/components/prescriber/MapPrescriber.vue';
import ProgramsList from '@/components/prescriber/ProgramsList.vue';
import ProgramDetails from '@/views/prescriber/ProgramDetails.vue';
import FiltersModule from '@/store/FiltersModule';
import ListModule from '../../store/ListModule';
import VxBreadcrumb from '@/layouts/components/VxBreadcrumb.vue';
import AuthModule from '../../store/AuthModule';
import { BACKEND_URL } from '@/helpers/constants';

interface ProgramTab {
    id: number;
    name: string;
}

@Component({
    components: {
        SideBarLayout,
        SideBarPrescriber,
        ProgramsList,
        MapPrescriber,
        VxBreadcrumb,
        ProgramDetails,
    },
})
export default class HomePrescriber extends Vue {
    fullscreen: boolean = true;
    sidebarVisible: boolean = false;
    showList: boolean = false;
    activeTab: string | number = 'map';
    programTabs: ProgramTab[] = [];
    showTrialPopup: boolean = false;

    get firstname() {
        return AuthModule.firstname;
    }

    get lastname() {
        return AuthModule.lastname;
    }

    get logo() {
        return AuthModule.logo;
    }

    get isSubscribed() {
        return AuthModule.isSubscriptionActive;
    }

    get isTrial() {
        return AuthModule.isTrialActive;
    }

    get backendUrl() {
        return BACKEND_URL;
    }

    get privateMode() {
        return FiltersModule.privateMode;
    }

    get businessDevelopper() {
    return AuthModule.business_developper;
}


    get isPrivateMode() {
        return FiltersModule.privateMode;
    }

    togglePrivateMode() {
        if (this.isTrial) {
            if (this.isPrivateMode) {
                return;
            }
            this.showTrialPopup = true;
            return;
        }
        FiltersModule.togglePrivateMode();
    }


    canvasAnimationId: number = 0;

    @Watch('showTrialPopup')
    onShowTrialPopupChange(val: boolean) {
        if (val) {
            this.$nextTick(() => {
                this.initCanvas();
            });
        }
    }

    initCanvas() {
        const canvas = this.$refs.trialCanvas as HTMLCanvasElement;
        if (!canvas) return;
        
        const ctx = canvas.getContext('2d');
        if (!ctx) return;

        canvas.width = canvas.offsetWidth;
        canvas.height = canvas.offsetHeight;

        const particles: any[] = [];
        for (let i = 0; i < 40; i++) {
            particles.push({
                x: Math.random() * canvas.width,
                y: Math.random() * canvas.height,
                radius: Math.random() * 2 + 0.5,
                vx: Math.random() * 0.4 - 0.2,
                vy: Math.random() * 0.4 - 0.2,
                alpha: Math.random() * 0.5 + 0.1
            });
        }

        const draw = () => {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            
            particles.forEach(p => {
                p.x += p.vx;
                p.y += p.vy;

                if (p.x < 0 || p.x > canvas.width) p.vx *= -1;
                if (p.y < 0 || p.y > canvas.height) p.vy *= -1;

                ctx.beginPath();
                ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2);
                ctx.fillStyle = `rgba(255, 255, 255, ${p.alpha})`;
                ctx.fill();
            });

            this.canvasAnimationId = requestAnimationFrame(draw);
        };

        draw();
    }

    closePopup() {
        this.showTrialPopup = false;
        if (this.canvasAnimationId) {
            cancelAnimationFrame(this.canvasAnimationId);
        }
    }



    setPrimaryColor(hexColor: string): void {
        const r: number = parseInt(hexColor.slice(1, 3), 16);
        const g: number = parseInt(hexColor.slice(3, 5), 16);
        const b: number = parseInt(hexColor.slice(5, 7), 16);
        document.documentElement.style.setProperty('--primary-color', hexColor);
        document.documentElement.style.setProperty('--vs-primary', `${r}, ${g}, ${b}`);
        document.documentElement.style.setProperty('--vs-personal_color', `${r}, ${g}, ${b}`);
    }

    getUserPrimaryColor(): string {
        const authJson = localStorage.getItem('auth');
        if (authJson) {
            try {
                const auth = JSON.parse(authJson);
                return auth.personal_color || '#ff5733';
            } catch {
                return '#ff5733';
            }
        }
        return '#ff5733';
    }

    initializeUserColor(): void {
        const personalColor = this.getUserPrimaryColor();
        this.setPrimaryColor(personalColor);
    }


    async mounted() {
        this.initializeUserColor();

        let hasDenouncePrograms = false;
        try {
            const raw = localStorage.getItem('denounce_selected_program_ids');
            if (raw) {
                const ids = JSON.parse(raw);
                hasDenouncePrograms = ids.length > 0;
            }
        } catch (e) {}

        if (hasDenouncePrograms) {
            this.showList = true;
            this.fullscreen = false;
        }

        this.$root.$on('openProgramTab', (programId: number, programName: string) => {
            this.openProgramTab(programId, programName);
        });

        this.$nextTick(() => {
            this.updateArrowVisibility();
            const tabs = this.$refs.navigationTabs as HTMLElement;
            if (tabs) {
                tabs.addEventListener('scroll', this.updateArrowVisibility);
            }
        });
}


    beforeDestroy() {
        this.$root.$off('openProgramTab');
        const tabs = this.$refs.navigationTabs as HTMLElement;
        if (tabs) {
            tabs.removeEventListener('scroll', this.updateArrowVisibility);
        }

    }

    async created() {
    }

    toggleSidebar(): void {
        this.sidebarVisible = !this.sidebarVisible;
        this.$nextTick(() => {
            window.dispatchEvent(new Event('resize'));
        });
    }

    showListView(): void {
        this.showList = true;
        this.fullscreen = false;
        this.$nextTick(() => {
            window.dispatchEvent(new Event('resize'));
        });
    }

    @Watch('fullscreen')
    onFullscreenChange(isFullscreen: boolean) {
        this.showList = !isFullscreen;
        this.$nextTick(() => {
            window.dispatchEvent(new Event('resize'));
        });
    }

    get show() {
        return FiltersModule.show;
    }

    get meta() {
        return ListModule.meta;
    }

    get isRestricted() {
        return AuthModule.isRestricted;
    }

    openProgramTab(programId: number, programName: string) {
        const existingTab = this.programTabs.find(tab => tab.id === programId);
        
        if (existingTab) {
            this.activeTab = programId;
            return;
        }
        
        this.programTabs.push({
            id: programId,
            name: programName
        });
        
        this.$nextTick(() => {
            this.updateArrowVisibility();
        });

        this.activeTab = programId;
    }

    switchToMap() {
        this.activeTab = 'map';
        this.$nextTick(() => {
            window.dispatchEvent(new Event('resize'));
        });
    }

    switchToProgram(programId: number) {
        this.activeTab = programId;
    }

    closeTab(tabId: string | number) {
        if (tabId === 'map') {
            return;
        }
        
        const index = this.programTabs.findIndex(tab => tab.id === tabId);
        if (index !== -1) {
            this.programTabs.splice(index, 1);
            
            if (this.activeTab === tabId) {
                if (this.programTabs.length > 0) {
                    this.activeTab = this.programTabs[this.programTabs.length - 1].id;
                } else {
                    this.activeTab = 'map';
                }
            }
        }

        this.$nextTick(() => {
            this.updateArrowVisibility();
        });

    }


    showLeftArrow: boolean = false;
    showRightArrow: boolean = false;

    scrollTabsLeft() {
    const tabs = this.$refs.navigationTabs as HTMLElement;
    if (tabs) {
        tabs.scrollBy({ left: -200, behavior: 'smooth' });
    }
        }

        scrollTabsRight() {
            const tabs = this.$refs.navigationTabs as HTMLElement;
            if (tabs) {
                tabs.scrollBy({ left: 200, behavior: 'smooth' });
            }
        }

 
updateArrowVisibility() {
    const shouldShowArrows = this.programTabs.length > 3;
    
    const tabs = this.$refs.navigationTabs as HTMLElement;
    if (tabs && shouldShowArrows) {
        this.showLeftArrow = tabs.scrollLeft > 0;
        this.showRightArrow = tabs.scrollLeft < (tabs.scrollWidth - tabs.clientWidth);
    } else {
        this.showLeftArrow = false;
        this.showRightArrow = false;
    }
}



}
